import moment from 'moment'
import { ActivityType, ActivityViews, ActivityStatus } from '../../interfaces/activity'
import { FilterFieldType, IFilter } from './types'

export const ACTIVE_STATUSES = [
  ActivityStatus.NotStarted,
  ActivityStatus.InProgress,
  ActivityStatus.Review,
]

export const ACTIVITIES_LIST_FILTERS_CONFIG = [
  {
    title: 'View',
    field: 'view',
    alias: 'activity',
    type: FilterFieldType.List,
    excludeColumn: true,
    isCustom: true,
    options: Object.keys(ActivityViews).map((value) => ({
      value,
      label: value,
    })),
  },
  {
    field: 'type',
    type: FilterFieldType.List,
    isMultiple: true,
    isSortable: true,
    options: [
      {
        value: 'all',
        label: 'All',
      },
      ...Object.values(ActivityType).map((value) => ({
        value,
        label: value,
      })),
    ],
    title: 'Type',
    alias: 'activity',
  },
  {
    field: 'clientName',
    dbField: 'client_name',
    type: FilterFieldType.Autocomplete,
    isSortable: true,
    placeholder: 'Client',
    title: 'Client',
    alias: 'activity',
  },
  {
    field: 'users',
    type: FilterFieldType.Autocomplete,
    isCustom: true,
    isSortable: true,
    placeholder: 'User',
    title: 'User',
  },
  {
    field: 'createdAt',
    type: FilterFieldType.Date,
    isCustom: true,
    isSortable: true,
    title: 'Date range',
    alias: 'activity',
    isExternalField: true,
  },
  {
    title: 'Status',
    field: 'status',
    alias: 'activity',
    type: FilterFieldType.List,
    isMultiple: true,
    isSortable: true,
    options: Object.values(ActivityStatus).map((value) => ({
      value,
      label: value,
    })),
  },
  {
    type: FilterFieldType.QuickFilter,
    field: 'quickFilter',
    fields: [
      {
        field: 'isCompleted',
        type: FilterFieldType.Text,
      },
      {
        field: 'isActive',
        type: FilterFieldType.Text,
      },
    ],

    quickFilters: [
      {
        title: 'Active',
        filters: {
          status: ACTIVE_STATUSES,
          isActive: true,
        },
      },
      {
        title: 'Completed Today',
        // A getter, not a literal: this config is a module-level constant, so a plain
        // object would freeze "today" at import time and keep querying that date for the
        // life of the session. Every read re-evaluates, so the filter follows the clock.
        get filters() {
          const today = moment().format('YYYY-MM-DD')
          return {
            isCompleted: true,
            createdAtFrom: today,
            createdAtTo: today,
          }
        },
      },
      {
        title: 'Assigned To Me',
        filters: {
          users: [],
          status: ACTIVE_STATUSES,
          isActive: true,
        },
      },
    ],
  },
  {
    field: 'first_name',
    type: FilterFieldType.Text,
    alias: 'requester',
    excludeColumn: true,
  },
  {
    field: 'last_name',
    type: FilterFieldType.Text,
    alias: 'requester',
    excludeColumn: true,
  },
  {
    field: 'first_name',
    type: FilterFieldType.Text,
    alias: 'processor',
    excludeColumn: true,
  },
  {
    field: 'last_name',
    type: FilterFieldType.Text,
    alias: 'processor',
    excludeColumn: true,
  },
  {
    field: 'first_name',
    type: FilterFieldType.Text,
    alias: 'reviewer',
    excludeColumn: true,
  },
  {
    field: 'last_name',
    type: FilterFieldType.Text,
    alias: 'reviewer',
    excludeColumn: true,
  },
  {
    field: 'isActive',
    type: FilterFieldType.Boolean,
    alias: 'activity',
    excludeColumn: true,
    excludeFilter: true,
  },
] as const satisfies IFilter[]
